<template>
  <div class="video-wrap">
    <div>
      <el-link type="primary"
               @click="backFn">&lt; 返回</el-link>
    </div>
    <div class="subtitle">
      <h4>
        经营类目
        <el-tag size="mini"
                effect="plain"
                style="fontsize: 12px; font-weight: 400; padding: 2px 12px"
                @click="
            dialogFormVisible = true;
            keyword = '';
          ">添 加</el-tag>
      </h4>
    </div>
    <div class="tableWrap">
      <el-table :data="strandTable"
                border
                style="width: 100%">
        <el-table-column align="center"
                         prop="id"
                         width="200px"
                         label="ID">
        </el-table-column>
        <el-table-column align="center"
                         prop="value"
                         label="商品标准名称">
        </el-table-column>
        <el-table-column align="center"
                         width="200px"
                         label="操作">
          <template slot-scope="{ row }">
            <el-link @click="deleteItem(row)"
                     type="primary">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="subtitle">
      <h4>所需资质</h4>
    </div>
    <div class="tableWrap">
      <el-table :data="talentList"
                border
                style="width: 100%">
        <el-table-column prop="name"
                         label="资质列表">
          <template slot-scope="{ row }">
            <p>商品标准名称：{{ row.category_name }}</p>
            <p style="font-size: 14px; color: #666; margin: 8px 0">{{ row.name }}</p>
            <p style="font-size: 14px; color: red; margin: 8px 0"
               :style="row.is_must == 1 ? 'color: red' : 'color: blue'">
              <span v-if="row.is_must == 1">必选资质 </span>
              <span v-if="row.is_must == 0">选填资质 </span>
            </p>
            <el-upload action="#"
                       :auto-upload="false"
                       :file-list="row.file"
                       :limit="1"
                       :show-file-list="true"
                       :on-preview="(file) => handlePreview(file, 1, row.url)"
                       :on-change="
                (file, fileList) => handleChange(file, fileList, 1, row.id)
              "
                       :on-remove="
                (file, fileList) => handleRemove(file, fileList, 1, row.id)
              ">
              <el-button size="mini" 
                         type="primary">点击上传</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="explain"
                         label="详细说明">
          <template slot-scope="{ row }">
            {{ row.explain || "-" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <!--  @click="sureFn" -->
      <el-button type="primary"
                 @click="submit" :loading="updataFalse">提 交</el-button>
    </div>
    <!-- 弹框 -->
    <el-dialog title="经营类目"
               :modal="false"
               :visible.sync="dialogFormVisible">
      <el-autocomplete v-model="keyword"
                       style="width: 480px"
                       :fetch-suggestions="querySearchAsync"
                       @select="handleSelect"
                       placeholder="请输入关键字检索"
                       clearable></el-autocomplete>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="
            dialogFormVisible = false;
            item = {};
          ">取 消</el-button>
        <el-button type="primary"
                   @click="sureFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["shop_id", "typeId", "editData"],
  data () {
    return {
      dialogFormVisible: false,
      strandList: [],
      strandTable: [],
      keyword: "",
      talentList: [],
      restaurants: [],
      item: {},
      updataFalse:false,
    };
  },
  mounted () {
    console.log(this.typeId, "this.typeId", this.editData);
 console.log(this.talentList,'this.talentList---')
    if (this.typeId == 2) {
      this.strandTable = []
      this.strandTable.push({
        id: this.editData.standard_id,
        value: this.editData.standard_name
      })
      if (this.editData.talent_id) {
         this.talentList.push({
       id: this.editData.talent_id,
        name: this.editData.talent_name,
        category_name: this.editData.standard_name,
        is_must: this.editData.is_must,
        url:this.editData.talent_image_url,
        related_id: this.editData.standard_id,
        file: [
          {
            url: this.editData.talent_image_url,
            name: this.editData.talent_name
          }
        ],
         explain: this.editData.explain
      })
      }
     
    }
  },
  computed: {
    ...mapGetters(["getToken", "getUserInfo"]),
  },
  methods: {
    ...mapActions({
      standardList: "detect/standardList",
      categoryManges: "newshop/talentList",
      talentAdd: "newshop/talentAdd",
      uploadFile: "commodity/uploadFile", //  图片上传
    }),
    deleteItem (item) {
      this.talentList = this.talentList.filter((el, index) => {
        return item.value !== el.category_name;
      });
      this.strandTable.splice(this.strandTable.indexOf(item), 1);
    },
    backFn () {
      this.$emit("backFn");
    },
    sureFn (item) {
       let strandList_=[];
      this.dialogFormVisible = false;
      this.strandList.push(this.item);
      strandList_.push(this.item);
      this.strandTable = Array.from(new Set(this.strandTable.concat(strandList_)));
      this.categoryManges({
        token: this.getToken,
        cate_ids: this.item.id,
      }).then((data) => {
        if (data.code == 1) {
          data.data.forEach((el) => {
            this.strandList.forEach((elt) => {
              elt.related_id = this.item.id;
              el.category_name = elt.value;
            });
            return el;
          });
          this.talentList = this.talentList.concat(data.data);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    submitAPI () {
      let category_id = [];
      this.strandTable.forEach((el) => {
        category_id.push(el.id);
      });
      console.log(this.talentList,'this.talentList---')
      let talent_all = this.talentList.map((el) => {
        let obj = {
          url: el.url,
          related_id: el.related_id,
          id: el.id,
          name: el.name,
          is_must: el.is_must,
        };
        return obj;
      });
      this.updataFalse = true
      let params = {
        shop_id: this.shop_id,
        category_id: category_id.join(","),
        token: this.getToken,
        talent_all: talent_all,
      };
        if (this.typeId == 2) {params.id= this.editData.id}
      this.talentAdd(params)
        .then((res) => {
           this.updataFalse = false
          if (res.code == 1) {
            this.$emit('successFn')  
          }else{
             this.$message.error(res.msg);
          }
        })
        .catch((err) => { 
           this.updataFalse = true
           this.$message.error(err);

        });
    },
    submit () {
      if (this.strandTable.length>0) {
        let flag = true;
      if (this.talentList.length > 0) {
       
        flag = this.talentList.every((item) => {
           if (item.is_must == 1&&item.url&&item.url.length>0 ||item.is_must == 0) {
            return true
          } 
           console.log(flag,'this.talentList------编辑',item.url?.item.url.length> 0)
        });
        
          console.log(this.talentList,'this.talentList',flag)
        if (flag) {
          this.submitAPI();
        } else {
          this.$message.warning(`必传资质类目不能为空！`);
        }
      } else {
        this.submitAPI();
      }
      }else{
         this.$message.warning(`请输入内容！`);
      }
      
    },
    handleButton (val) {
      this.resultID = val;
    },
    querySearchAsync (queryString, cb) {
      if (queryString !== "") {
        let params = {
          keyword: queryString,
          token: this.getToken,
        };
        let restaurants = [];
        this.standardList(params).then((res) => {
          if (res.data.code == 1) {
            res.data.data.forEach((el) => {
              let obj = {
                value: el.name,
                id: el.standard_id,
              };
              restaurants.push(obj);
            });
            let results = restaurants.filter(this.createStateFilter(queryString));
            cb(results);
          } else {
            restaurants = [];
            cb(restaurants);
          }
        });
      }
    },
    createStateFilter (queryString) {
      return (state) => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect (item) {
      this.item = item;
    },
    /* 资质 */
    //文件上传
    handleChange (file, fileList, index, talent_id) {
     
      let i;
      if (index==1) {
         i = this.talentList.findIndex((item) => {
            return talent_id == item.id;
          });
          this.$set(this.talentList[i], "file", fileList);
      }
 var formdata = new FormData();
      formdata.append("img", file.raw);
       this.$message.success({message:"正在上传中，请稍后！",duration:3000});
      this.uploadFile(formdata).then((res) => {
        if (res.code == 200) {
          // console.log(res);
          this.$message.success("上传成功！");
          switch (index) {
            case 1:
              this.$set(this.talentList[i], "url", res.data);
              break;

            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //文件删除
    handleRemove (file, fileList, index, talent_id) {
      let i;
      switch (index) {
        case 1:
          i = this.talentList.findIndex((item) => {
            return talent_id == item.id;
          });
          this.$set(this.talentList[i], "file", []);
          break;
        default:
          break;
      }
    },

    /**
     * @API
     */
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.video-wrap {
  width: 100%;

  .subtitle {
    margin: 35px 0;
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 40px;
    }

    p {
      line-height: 18px;
      margin-left: 40px;

      span {
        margin-left: 14px;
        color: #ea5846;
      }
    }

    h4 {
      padding-left: 20px;
      line-height: 18px;
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #333333;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: #2448ff;
      }
    }
  }

  .tableWrap {
    margin-bottom: 10px;
  }
}
</style>
